module.exports = __webpack_public_path__ + "img/unlink-icon.3801e6ad.png";